import styled from 'styled-components';

export const IconStateWrapper = styled.div`
width: ${(props: any) => (props.isSourceFromAct ? '26px' : '16px')};
padding: 0px 5px;
svg {
  vertical-align: middle;
}
`
